import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";
import Icon from "../../Icon";

const ImageCard = () => {
  const [hover, setHover] = useState(false);

  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* IMAGE CARDS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Image Cards</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Basic Image Card</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="bg-gradient-to-br from-amber-500 to-blue-500 h-24 rounded mb-3"></div>
              <h4 className="text-sm font-semibold text-slate-100">Image Title</h4>
              <p className="text-xs text-slate-400 mt-1">2 hours ago</p>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="border border-slate-600 rounded overflow-hidden">
  <img src="image.jpg" className="w-full h-40 object-cover" />
  <div className="p-3">
    <h4 className="font-semibold">Title</h4>
    <p className="text-sm text-slate-400">2 hours ago</p>
  </div>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Image with Overlay</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="relative bg-gradient-to-br from-amber-500 to-amber-500 h-24 rounded group cursor-pointer">
                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity rounded flex items-center justify-center"><span className="text-white text-2xl"><Icon name="search" className="w-6 h-6" /></span></div>
              </div>
              <p className="text-xs text-slate-400 mt-2">Hover over image</p>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="relative group">
  <img src="image.jpg" className="w-full rounded" />
  <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 flex items-center justify-center">
    <span>Icon</span>
  </div>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Image with Badge</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="relative bg-gradient-to-br from-amber-500 to-amber-500 h-24 rounded">
                <div className="absolute top-2 right-2 px-2 py-1 bg-yellow-500 text-slate-900 text-xs font-bold rounded">NEW</div>
              </div>
              <p className="text-xs text-slate-400 mt-2">1 hour ago</p>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="relative">
  <img src="image.jpg" className="w-full rounded" />
  <div className="absolute top-2 right-2 px-2 py-1 bg-yellow-500 text-xs font-bold rounded">NEW</div>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Image with Rating</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="bg-slate-700 h-24 rounded mb-2 flex items-end justify-center pb-2"><span className="text-yellow-400 text-lg inline-flex gap-1"><Icon name="star" className="w-4 h-4" /><Icon name="star" className="w-4 h-4" /><Icon name="star" className="w-4 h-4" /><Icon name="star" className="w-4 h-4" /><Icon name="star" className="w-4 h-4" /></span></div>
              <p className="text-xs text-slate-400">4.0 rating (234 reviews)</p>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="flex items-center gap-2">
  <span className="text-yellow-400">Stars</span>
  <span className="text-xs text-slate-400">4.0 (234)</span>
</div>`} />
          </div>
        </div>
      </div>

      {/* ADVANCED IMAGE CARDS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Advanced Variants</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Portfolio Card</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="bg-gradient-to-br from-slate-700 to-slate-800 h-24 rounded mb-2"></div>
              <h4 className="text-sm font-semibold text-slate-100">Portfolio Project</h4>
              <p className="text-xs text-slate-400">Design - 3 months ago</p>
              <div className="flex gap-1 mt-2">{[1,2,3].map(i => <div key={i} className="w-5 h-5 rounded bg-amber-600 text-white text-xs flex items-center justify-center">+</div>)}</div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="border border-slate-600 rounded overflow-hidden">
  <div className="h-40 bg-gradient-to-br"></div>
  <div className="p-3">
    <h3 className="font-semibold">Project Title</h3>
    <p className="text-sm text-slate-400">Category - Date</p>
  </div>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Product Card</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="bg-slate-700 h-24 rounded mb-2 flex items-center justify-center"><span className="text-2xl"><Icon name="briefcase" className="w-7 h-7" /></span></div>
              <h4 className="text-sm font-semibold text-slate-100">Product Name</h4>
              <p className="text-xs text-slate-400 mt-1">$29.99</p>
              <button className="w-full mt-2 px-2 py-1 bg-amber-600 text-white text-xs rounded">Add to Cart</button>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="border rounded overflow-hidden">
  <img src="product.jpg" className="w-full h-40" />
  <div className="p-3">
    <h3>Product</h3>
    <p className="text-slate-400">$29.99</p>
    <button className="w-full mt-2">Add</button>
  </div>
</div>`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageCard;


